"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputPart = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const _part_includes_1 = require("../_part_includes");
const inputmask_1 = __importDefault(require("inputmask"));
//@ts-ignore                
let rwsTemplate = T.html `<div class="form-group ${x => x.type !== 'color' ? 'has-float-label' : 'color-label'} form-group rounded">
    ${(0, fast_element_1.when)(x => x.label && !x.hybridLabelMode, T.html `<label htmlFor="${x => x.name}" class="" part="label">${x => x.label.t()}</label>`)}   
    ${(0, fast_element_1.when)(x => x.hybridLabelMode && x.hybridLabelShowView, T.html `<p class="hybrid-label" @click="${(x, c) => x.handleClick(c.event)}"><span class="badge badge-info" style="background-color: ${x => x.badgeColor};">${x => x.value}</span></p>`)}
    ${(0, fast_element_1.when)(x => (x.hybridLabelMode && !x.hybridLabelShowView) || !x.hybridLabelMode, T.html `<input 
        ${(0, fast_element_1.ref)('inputField')}
        part="input"
        type="${x => x.type ? x.type : 'input'}" 
        @change="${(x, c) => x.handleChange(c.event)}"         
        name="${x => x.name}" 
        class="form-control" 
        :value="${x => x.value}"
        step="${x => x.step ? x.step : ''}"
        min="${x => x.min ? x.min : ''}"
        max="${x => x.max ? x.max : ''}"
        ?required="${x => x.isRequired}"
        placeholder="${x => x.placeholder ? x.placeholder.t() : ''}"
        />`)}
</div>
`;
require("./styles/layout.scss");
const styles = T.css `:host-context(.force-placeholder) input::placeholder,
select::placeholder,
textarea::placeholder {
  opacity: 1 !important;
}

.form-group.is-invalid label {
  color: var(--error_color) !important;
}
.form-group.is-invalid .form-control {
  border-color: var(--error_color) !important;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075) !important;
  color: var(--error_color) !important;
}

:host(.no-margin) .form-group {
  margin: 0 !important;
}

:host(.mini) .form-control {
  padding: 0.2rem 0.4rem;
  line-height: 0.8;
  font-size: 0.6rem;
}

:host(.rounded) .form-control {
  border-radius: 0.375rem;
}

:host(.left-p-30) input {
  padding-left: 30px;
}

:host(.no-margin) {
  margin: 0 !important;
}
:host(.no-margin) input {
  margin: 0 !important;
}
:host(.no-margin) .form-group {
  margin: 0 !important;
}

:host(.small) input {
  width: 70px;
}

.no-label {
  margin-left: 0;
}

.form-group.rounded input[type=text],
.form-group.rounded input[type=number],
.form-group.rounded input[type=email],
.form-group.rounded input[type=password],
.form-group.rounded input[type=tel],
.form-group.rounded input[type=url],
.form-group.rounded input[type=search],
.form-group.rounded input[type=date],
.form-group.rounded input:not([type]) {
  border: 1px solid var(--brand-border, #e4e7ec);
  border-radius: 8px;
  color: var(--ink, #2f2f3a);
  background: #fff;
  font-size: 0.95rem;
  padding: 0.55rem 0.75rem;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.form-group.rounded input::placeholder {
  color: var(--muted, #8a8f9c);
  opacity: 1;
}

.form-group.rounded input[type=text]:focus,
.form-group.rounded input[type=number]:focus,
.form-group.rounded input[type=email]:focus,
.form-group.rounded input[type=password]:focus,
.form-group.rounded input[type=tel]:focus,
.form-group.rounded input[type=url]:focus,
.form-group.rounded input[type=search]:focus,
.form-group.rounded input[type=date]:focus,
.form-group.rounded input:not([type]):focus {
  border-color: var(--brand, #17b4a6);
  box-shadow: 0 0 0 0.2rem rgba(23, 180, 166, 0.2);
  outline: none;
}

.form-group.rounded input:focus::placeholder {
  color: var(--muted, #8a8f9c);
  opacity: 1;
}

input[type=color] {
  width: var(--color_input_size, 30px);
  height: var(--color_input_size, 30px);
  border-radius: 50%;
  padding: 3px;
}

.color-label {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
}

.hybrid-label {
  margin-top: 0.5rem;
  font-size: 1.2rem;
  font-weight: bold;
  cursor: pointer;
}`;
const shadowOptions = { "mode": "open" };
let InputPart = class InputPart extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.value = '';
        this.hybridLabelMode = false;
        this.ignored = 'false';
        this.dontEmit = false;
        this.hybridLabelShowView = true;
        this.badgeColor = '#3195a5';
        this.handleChange = function (event) {
            if (this.hybridLabelMode) {
                this.hybridLabelShowView = true;
                this.sendHybridChange();
            }
            return _part_includes_1.handlePartChange.bind(this)(event);
        }.bind(this);
    }
    sendHybridChange() {
        this.$emit('input:hybrid-change', { name: this.name, labelShow: this.hybridLabelShowView });
    }
    requiredChanged(oldValue, newValue) {
        this.required = newValue;
        this.isRequired = !this.hybridLabelMode && this.required === 'true';
    }
    getElement() {
        return this.inputField;
    }
    connectedCallback() {
        super.connectedCallback();
        // this.safeValue = this.value || '';
        if (this.mask) {
            this.maskOptions = { ...this.maskOptions,
                placeholder: "_",
                jitMasking: true,
                positionCaretOnClick: "lvp"
            };
            this.inputMask = new inputmask_1.default(this.mask, this.maskOptions || {});
            this.inputMask.mask(this.getElement());
            // if (this.value) {
            //   this.getElement().value = this.value;
            // }
        }
    }
    reset() {
        this.$('input').value = null;
        this.value = '';
    }
    handleClick(e) {
        if (this.hybridLabelMode) {
            this.hybridLabelShowView = !this.hybridLabelShowView;
            this.sendHybridChange();
        }
    }
};
exports.InputPart = InputPart;
InputPart.PART_TYPE = 'input';
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], InputPart.prototype, "label", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], InputPart.prototype, "name", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], InputPart.prototype, "value", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], InputPart.prototype, "type", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], InputPart.prototype, "step", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], InputPart.prototype, "min", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Object)
], InputPart.prototype, "hybridLabelMode", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], InputPart.prototype, "max", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], InputPart.prototype, "required", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], InputPart.prototype, "placeholder", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], InputPart.prototype, "ignored", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], InputPart.prototype, "dontEmit", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], InputPart.prototype, "mask", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof inputmask_1.default !== "undefined" && inputmask_1.default.Options) === "function" ? _a : Object)
], InputPart.prototype, "maskOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], InputPart.prototype, "hybridLabelShowView", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], InputPart.prototype, "isRequired", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Function)
], InputPart.prototype, "onChange", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], InputPart.prototype, "badgeColor", void 0);
exports.InputPart = InputPart = __decorate([
    (0, client_1.RWSView)('part-input', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], InputPart);
InputPart.defineComponent();
